<template>
  <div class="minBox relative">
    <div class="title">
      <div class="title_left">
        <span class="movePoin" @click="$router.go(-1)">溯源检测</span>
      </div>
    </div>
    <div class="tabBox">
      <span :class="tabOkSapn==1?'okSpan':''" @click="tabOkSapn = 1">待检测</span>
      <span :class="tabOkSapn==2?'okSpan':''" @click="tabOkSapn = 2">已完成</span>
    </div>
    <detectionDjc></detectionDjc>
  </div>
</template>
<script>
  import detectionDjc from './detectionDjc.vue'
  export default {
    components: {
      detectionDjc
    },
    data() {
      return {
        tabOkSapn: 1
      }
    },
  }
</script>
<style scoped lang='scss'>
  .minBox {
    width: calc(100% - 40px);
    min-height: calc(100% - 100px);
    padding: 0 20px 100px 20px;
    .title {
      height: 60px;
      line-height: 60px;
      .title_left {
        font-size: 20px;
        font-weight: 400;
        color: rgba(51, 51, 51, 1);
        width: 50%;
        height: 100%;
        .type {
          color: #70ce97;
        }
      }
    }
  }
  .tabBox{
    background-color: #fff;
    margin-bottom: 10px;
    padding: 0 40px;
    box-shadow: 0px 2px 4px 0px rgba(221, 221, 221, 0.5);
    border-radius: 4px;
    span{
      cursor: pointer;
      color: #666;
      font-size: 16px;
      border-bottom: 4px solid rgba(0,0,0,0);
      display: inline-block;
      width: 100px;
      line-height: 46px;
      text-align: center; 
      margin-right: 10px;
    }
    .okSpan{
      border-bottom: 4px solid #70CE97;
      color: #70CE97;
    }
  }
</style>